<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="200px"
      >
        <v-btn
          class="mt-6"
          text
          color="blue"
          @click="handleClose"
        >
          cerrar
        </v-btn>
        <div class="py-3">
          <h3>Nuevo funcionalidad "Abrir ticket"<br/></h3>
          Ahora puedes abrir una <b>solicitud</b> a <b>Descubregroup</b> abriendo un ticket pulsando en el menú de usuario <v-icon
          x-large 
          color="#CCCCCC"
        >
          mdi-cog-outline
        </v-icon> (arriba a la derecha) y lugo en el menú 
        <v-btn
          color="green"
          dark
        >
          Abrir ticket
        </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  data: () => ({
    sheet: false
  }),
  mounted () {
    if (localStorage.getItem(`newFeatureTicket`) !== 'true') this.sheet = true
  },
  methods: {
    handleClose () {
      localStorage.setItem(`newFeatureTicket`, 'true')
      this.sheet = false
    },
  },
}
</script>

